import { render, staticRenderFns } from "./ReIssueChangePassword.vue?vue&type=template&id=219ea50d&"
import script from "./ReIssueChangePassword.vue?vue&type=script&lang=js&"
export * from "./ReIssueChangePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports